<template>
    <TabLayout
        :title="Lang.get('employeedashboard::pages/settings/account.edit.title')"
        :subtitle="Lang.get('employeedashboard::pages/settings/account.edit.subtitle')"
        tabName="account">

        <form @submit.prevent="submit()">
                <div class="row">
                    <div class="form-group col-md-4">
                        <text-input
                            v-model="form.first_name"
                            :label="Lang.get('employeedashboard::shared.first_name')"
                            :placeholder="Lang.get('employeedashboard::shared.placeholder.first_name')"
                            :error="errors.first_name"
                            :isValidated="isValidated"
                            :isRequired="true"
                        />
                    </div>
                    <div class="form-group col-md-4">
                        <text-input
                            v-model="form.middle_name"
                            :label="Lang.get('employeedashboard::shared.middle_name')"
                            :placeholder="Lang.get('employeedashboard::shared.placeholder.middle_name')"
                            :error="errors.middlename"
                        />
                    </div>
                    <div class="form-group col-md-4">
                        <text-input
                            v-model="form.last_name"
                            :label="Lang.get('employeedashboard::shared.last_name')"
                            :placeholder="Lang.get('employeedashboard::shared.placeholder.last_name')"
                            :error="errors.last_name"
                            :isValidated="isValidated"
                            :isRequired="true"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="form-group col-md-4">
                        <label class="font-poppins color-dark-blue">{{ Lang.get('employeedashboard::shared.date_of_birth') }}
                            <span class="d-inline-block badge badge-primary" tabindex="0" data-toggle="tooltip" :title="Lang.get('employeedashboard::shared.cannot_change_date_of_birth') + '*'">
                                <i class="fa fa-question"></i>
                            </span>
                        </label>
                        <text-input
                            v-model="form.date_of_birth"
                            :placeholder="Lang.get('employeedashboard::shared.placeholder.date_of_birth')"
                            :disabled="true"
                        />
                    </div>
                    <div class="form-group col-md-4">
                        <label class="font-poppins color-dark-blue">{{ Lang.get('employeedashboard::shared.birth_place') }}
                            <span class="d-inline-block badge badge-primary" tabindex="0" data-toggle="tooltip" :title="Lang.get('employeedashboard::shared.cannot_change_birthplace') + '*'">
                                <i class="fa fa-question"></i>
                            </span>
                        </label>
                        <text-input
                            v-model="form.birthplace"
                            :disabled="true"
                        />
                    </div>
                </div>
                <hr />
            <div class="row">
                <div class="form-group col-md-4">
                    <select-input
                        v-model="form.educational_level"
                        :label="Lang.get('generic.educational_attainment')"
                        :placeholder="Lang.get('generic.placeholder.educational_attainment')"
                        :error="errors.educational_level"
                        :isValidated="isValidated">
                        <option :value="null">{{ Lang.get('employeedashboard::shared.choose') }}</option>
                        <option v-for="(education, index) in educational_level_options" :value="index">{{ education }}</option>
                    </select-input>
                </div>
                <div class="form-group col-md-4">
                    <text-input
                        v-model="form.function_description"
                        :label="Lang.get('employeedashboard::shared.function')"
                        :placeholder="Lang.get('employeedashboard::shared.placeholder.function')"
                        :error="errors.function_description"
                        :isValidated="isValidated"
                    />
                </div>
            </div>
            <hr />
                <SubmitButton class="mt-3 mb-4">
                    {{ Lang.get('employeedashboard::shared.save.button')}}
                </SubmitButton>
        </form>
    </TabLayout>
</template>

<script>
import TabLayout from "@/Pages/Settings/Shared/TabLayout"
import TextInput from "@/Shared/TextInput";
import FlashMessages from "@/Shared/FlashMessages";
import Checkbox from "@/Shared/Checkbox";
import FormError from "@/Shared/FormError";
import SelectInput from "@/Shared/SelectInput";
import SubmitButton from "@/Shared/SubmitButton";

export default {
    metaInfo: { title: Lang.get('employeedashboard::pages/settings/account.edit.title') },
    components: {
        FormError,
        Checkbox,
        TextInput,
        FlashMessages,
        SelectInput,
        TabLayout,
        SubmitButton,
    },
    props: {
        errors: Object,
        account: Object,
        educational_level_options: Object,
        isValidated: Object,
    },

    data() {
        return {
            form: this.$inertia.form({
                date_of_birth: this.account.date_of_birth,
                birthplace: this.account.birthplace,
                remote_reference: this.account.remote_reference,
                first_name: this.account.first_name,
                middle_name: this.account.middle_name,
                last_name: this.account.last_name,
                current_password: '',
                function_description: this.account.function_description,
                educational_level: this.account.educational_level,
            }),
        }
    },
    methods: {
        submit() {
            this.form.put(this.route('nl.employeedashboard.settings.account.update.attempt'));
        },
    },

    created() {
        $(function () {
            $('[data-toggle="tooltip"]').tooltip()
        });
    }
}
</script>
